// Drag past this = a move or a pan, not a tap (~iOS tap tolerance).
export const MOVE_SLOP_PX = 10

// Detected ourselves, not native dblclick: iOS fires it unreliably (a single tap can synthesize one).
const DOUBLE_TAP_MS = 300
const DOUBLE_TAP_PX = 24

// One record for every text tap, whichever element took it, so a first tap that swaps the box
// from GL text to a DOM box still pairs with a second tap on the box it swapped to.
export class TextTapRecord {
  private last: { id: string; x: number; y: number; t: number } | null = null

  // A second tap on the same box, close in time and place, edits; anything else selects.
  public tap(id: string, x: number, y: number, t: number): 'select' | 'edit' {
    const prev = this.last
    if (
      prev?.id === id &&
      t - prev.t < DOUBLE_TAP_MS &&
      Math.hypot(x - prev.x, y - prev.y) < DOUBLE_TAP_PX
    ) {
      this.last = null
      return 'edit'
    }
    this.last = { id, x, y, t }
    return 'select'
  }

  // A drag (move, resize, pan) is never a tap and must not pair into a double-tap.
  public cancel(): void {
    this.last = null
  }
}
